import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=1a3eacf2&scoped=true"
import script from "./pagenation.vue?vue&type=script&lang=js"
export * from "./pagenation.vue?vue&type=script&lang=js"
import style0 from "./pagenation.vue?vue&type=style&index=0&id=1a3eacf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3eacf2",
  null
  
)

export default component.exports